import React from 'react';
export function Contact() {
  return <section id="contact" className="py-24 bg-riskeys-gray-light" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-20" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-riskeys-dark mb-5 leading-tight" data-id="element-15">
            Nous <span className="text-riskeys-blue-default" data-id="element-16">contacter</span>
          </h2>
          <div className="w-20 h-1 bg-riskeys-accent-default mx-auto mb-6" data-id="element-17"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed" data-id="element-18">
            Prêt à optimiser vos contrats d'assurance ? Contactez-nous pour un
            audit gratuit et sans engagement.
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-premium overflow-hidden border border-gray-100" data-id="element-19">
          <div className="md:flex" data-id="element-20">
            <div className="md:w-1/2 p-8 md:p-12" data-id="element-21">
              <h3 className="text-2xl font-bold text-riskeys-dark mb-8" data-id="element-22">
                Demandez un audit gratuit
              </h3>
              <form className="space-y-6" data-id="element-23">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-24">
                  <div data-id="element-25">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-26">
                      Nom complet
                    </label>
                    <input type="text" id="name" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-riskeys-accent-default focus:border-riskeys-accent-default transition-colors bg-white" placeholder="Votre nom" data-id="element-27" />
                  </div>
                  <div data-id="element-28">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-29">
                      Entreprise
                    </label>
                    <input type="text" id="company" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-riskeys-blue-default focus:border-riskeys-blue-default transition-colors bg-white" placeholder="Nom de votre entreprise" data-id="element-30" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-31">
                  <div data-id="element-32">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-33">
                      Email professionnel
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-riskeys-blue-default focus:border-riskeys-blue-default transition-colors bg-white" placeholder="votreemail@entreprise.fr" data-id="element-34" />
                  </div>
                  <div data-id="element-35">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-36">
                      Téléphone
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-riskeys-blue-default focus:border-riskeys-blue-default transition-colors bg-white" placeholder="Votre numéro de téléphone" data-id="element-37" />
                  </div>
                </div>
                <div data-id="element-38">
                  <label htmlFor="sector" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-39">
                    Secteur d'activité
                  </label>
                  <select id="sector" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-riskeys-blue-default focus:border-riskeys-blue-default transition-colors bg-white" data-id="element-40">
                    <option value="" data-id="element-41">Sélectionnez votre secteur</option>
                    <option value="industrie" data-id="element-42">Industrie & Manufacturier</option>
                    <option value="construction" data-id="element-43">Construction & BTP</option>
                    <option value="immobilier" data-id="element-44">Immobilier</option>
                    <option value="retail" data-id="element-45">Commerce & Distribution</option>
                    <option value="services" data-id="element-46">Services</option>
                    <option value="tech" data-id="element-47">Technologie & IT</option>
                    <option value="transport" data-id="element-48">Transport & Logistique</option>
                    <option value="public" data-id="element-49">Secteur Public</option>
                    <option value="autre" data-id="element-50">Autre</option>
                  </select>
                </div>
                <div data-id="element-51">
                  <label htmlFor="insurance_type" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-52">
                    Type de contrat à optimiser
                  </label>
                  <div className="grid grid-cols-2 gap-3" data-id="element-53">
                    <label className="flex items-center p-3 border border-gray-300 rounded-md cursor-pointer hover:border-riskeys-blue-light transition-colors" data-id="element-54">
                      <input type="checkbox" className="mr-2 text-riskeys-blue-default focus:ring-riskeys-blue-default" name="insurance_type" value="dommages" data-id="element-55" />
                      <span className="text-sm" data-id="element-56">Dommages aux biens</span>
                    </label>
                    <label className="flex items-center p-3 border border-gray-300 rounded-md cursor-pointer hover:border-riskeys-blue-light transition-colors" data-id="element-57">
                      <input type="checkbox" className="mr-2 text-riskeys-blue-default focus:ring-riskeys-blue-default" name="insurance_type" value="rc" data-id="element-58" />
                      <span className="text-sm" data-id="element-59">RC Professionnelle</span>
                    </label>
                    <label className="flex items-center p-3 border border-gray-300 rounded-md cursor-pointer hover:border-riskeys-blue-light transition-colors" data-id="element-60">
                      <input type="checkbox" className="mr-2 text-riskeys-blue-default focus:ring-riskeys-blue-default" name="insurance_type" value="flotte" data-id="element-61" />
                      <span className="text-sm" data-id="element-62">Flotte automobile</span>
                    </label>
                    <label className="flex items-center p-3 border border-gray-300 rounded-md cursor-pointer hover:border-riskeys-blue-light transition-colors" data-id="element-63">
                      <input type="checkbox" className="mr-2 text-riskeys-blue-default focus:ring-riskeys-blue-default" name="insurance_type" value="sante" data-id="element-64" />
                      <span className="text-sm" data-id="element-65">Santé & Prévoyance</span>
                    </label>
                  </div>
                </div>
                <div data-id="element-66">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-67">
                    Message
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-riskeys-blue-default focus:border-riskeys-blue-default transition-colors bg-white" placeholder="Décrivez brièvement vos besoins et objectifs" data-id="element-68"></textarea>
                </div>
                <div data-id="element-69">
                  <button type="submit" className="w-full bg-riskeys-accent-default text-white py-3.5 px-6 rounded-md hover:bg-riskeys-accent-dark transition-all duration-300 font-semibold shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-70">
                    Demander un audit gratuit
                  </button>
                </div>
              </form>
            </div>
            <div className="md:w-1/2 bg-gradient-to-br from-riskeys-dark to-riskeys-blue-dark p-8 md:p-12 text-white relative overflow-hidden" data-id="element-71">
              {/* Background pattern */}
              <div className="absolute inset-0 bg-blue-900 opacity-10" data-id="element-72">
                <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full" data-id="element-73">
                  <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" patternContentUnits="userSpaceOnUse" data-id="element-74">
                    <circle cx="10" cy="10" r="1" fill="white" data-id="element-75"></circle>
                  </pattern>
                  <rect x="0" y="0" width="100%" height="100%" fill="url(#dots)" data-id="element-76"></rect>
                </svg>
              </div>
              <div className="relative z-10" data-id="element-77">
                <h3 className="text-2xl font-bold mb-8" data-id="element-78">Notre engagement</h3>
                <div className="space-y-8" data-id="element-79">
                  <div className="flex items-start" data-id="element-80">
                    <div className="flex-shrink-0 h-12 w-12 rounded-md bg-riskeys-accent-default flex items-center justify-center mr-4 shadow-md" data-id="element-81">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-riskeys-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-82">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-83" />
                      </svg>
                    </div>
                    <div data-id="element-84">
                      <h4 className="text-lg font-semibold mb-2" data-id="element-85">
                        Audit gratuit et sans engagement
                      </h4>
                      <p className="text-white/80 leading-relaxed" data-id="element-86">
                        Nous examinons vos contrats actuels et identifions les
                        potentielles économies sans aucun frais initial et sans
                        engagement.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-87">
                    <div className="flex-shrink-0 h-12 w-12 rounded-md bg-white/20 backdrop-blur-sm flex items-center justify-center mr-4 shadow-md" data-id="element-88">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-89">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-90" />
                      </svg>
                    </div>
                    <div data-id="element-91">
                      <h4 className="text-lg font-semibold mb-2" data-id="element-92">
                        Paiement uniquement au résultat
                      </h4>
                      <p className="text-white/80 leading-relaxed" data-id="element-93">
                        Vous ne payez que si nous générons des économies. Notre
                        rémunération est un pourcentage des économies réalisées.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-94">
                    <div className="flex-shrink-0 h-12 w-12 rounded-md bg-riskeys-accent-default flex items-center justify-center mr-4 shadow-md" data-id="element-95">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-riskeys-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-96">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-97" />
                      </svg>
                    </div>
                    <div data-id="element-98">
                      <h4 className="text-lg font-semibold mb-2" data-id="element-99">
                        Processus simple et non-intrusif
                      </h4>
                      <p className="text-white/80 leading-relaxed" data-id="element-100">
                        Notre intervention est non intrusive et ne perturbe pas
                        votre activité. Nous prenons en charge toute la
                        négociation avec vos assureurs.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-12 pt-8 border-t border-white/20" data-id="element-101">
                  <h4 className="text-lg font-semibold mb-5" data-id="element-102">
                    Contactez-nous directement
                  </h4>
                  <div className="space-y-4" data-id="element-103">
                    <div className="flex items-center" data-id="element-104">
                      <div className="w-10 h-10 rounded-md bg-white/10 flex items-center justify-center mr-4" data-id="element-105">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-106">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-107" />
                        </svg>
                      </div>
                      <span className="text-white/90" data-id="element-108">0033 6 67 64 74 25</span>
                    </div>
                    <div className="flex items-center" data-id="element-109">
                      <div className="w-10 h-10 rounded-md bg-white/10 flex items-center justify-center mr-4" data-id="element-110">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-111">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-112" />
                        </svg>
                      </div>
                      <span className="text-white/90" data-id="element-113">
                        consulting@riskeys.fr
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-114">
                      <div className="w-10 h-10 rounded-md bg-white/10 flex items-center justify-center mr-4" data-id="element-115">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-116">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-117" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-118" />
                        </svg>
                      </div>
                      <span className="text-white/90" data-id="element-119">
                        108 BOULEVARD CHARLES DE GAULLE
                        <br data-id="element-120" />
                        92700 COLOMBES
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}